module.exports = __webpack_public_path__ + "static/media/zm.0c052579.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/zm.svg
// module id = 2247
// module chunks = 0